import { render, staticRenderFns } from "./sentence.vue?vue&type=template&id=1fc4a895&scoped=true&"
import script from "./sentence.vue?vue&type=script&lang=js&"
export * from "./sentence.vue?vue&type=script&lang=js&"
import style0 from "./sentence.vue?vue&type=style&index=0&id=1fc4a895&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4a895",
  null
  
)

export default component.exports